<template>
	<vue-scroll class="page-element-datetime-picker">
		<div class="page-header">
			<h1>Element Date Time Picker
				<theme-picker style="float:right"></theme-picker>
			</h1>
			<h4><a href="http://element.eleme.io/#/en-US/component/datetime-picker" target="_blank"><i class="mdi mdi-book-open-page-variant"></i> see from the complete documentation</a></h4>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white">
			<el-collapse value="1">
				<el-collapse-item title="Date and time" name="1">
					<div class="block">
						<el-date-picker
						v-model="value1"
						type="datetime"
						placeholder="Select date and time">
						</el-date-picker>
					</div>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code1"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white hidden-xs-only">
			<el-collapse value="1">
				<el-collapse-item title="Date and time range" name="1">
					<div class="block">
						<el-date-picker
						v-model="value4"
						type="datetimerange"
						:picker-options="pickerOptions2"
						range-separator="To"
						start-placeholder="Start date"
						end-placeholder="End date"
						align="right">
						</el-date-picker>
					</div>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code2"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
	</vue-scroll>
</template>

<script>
import ThemePicker from '@/components/theme-picker'

export default {
	name: 'ElementDateTimePicker',
	data() {
		return {
			value1: '',
			pickerOptions2: {
			shortcuts: [{
				text: 'Last week',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit('pick', [start, end]);
				}
			}, {
				text: 'Last month',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				picker.$emit('pick', [start, end]);
				}
			}, {
				text: 'Last 3 months',
				onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				picker.$emit('pick', [start, end]);
				}
			}]
			},
			value3: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
			value4: '',
			code1: 
`
<div class="block">
	<span class="demonstration">Default</span>
	<el-date-picker
		v-model="value1"
		type="datetime"
		placeholder="Select date and time">
	</el-date-picker>
</div>`
		,code2:
`
<template>
  <div class="block">
    <el-date-picker
      v-model="value4"
      type="datetimerange"
      :picker-options="pickerOptions2"
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      align="right">
    </el-date-picker>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pickerOptions2: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value4: ''
      };
    }
  };
<\/script>
`
		}
	},
	components: {
		ThemePicker
	}
}
</script>

<style lang="scss" scoped>
.demo-box {
	padding: 20px;
	margin-bottom: 20px;
}
pre {
	margin: 0;
	background: white;
}
code {
	padding: 0;
}

@media (max-width: 768px) {code{font-size: 70%;}}

</style>

